import React, { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("gs_token");
    if (!token) { setLoading(false); return; }
    api.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => { localStorage.removeItem("gs_token"); })
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    localStorage.setItem("gs_token", r.data.token);
    setUser(r.data.user);
    return r.data;
  };
  const logout = () => {
    localStorage.removeItem("gs_token");
    setUser(null);
  };
  const setSession = (token, u) => {
    localStorage.setItem("gs_token", token);
    setUser(u);
  };

  return (
    <AuthCtx.Provider value={{ user, loading, login, logout, setSession }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
